import React, { useState, useEffect } from 'react';
import axios from '../../../api';

const Count = () => {
    // const [count, setCount] = useState(0);
    //
    //
    // useEffect(() => {
    //     axios.get('/paciente/count', { timeout: 5000 })
    //         .then(response => {
    //             const count = response.data; // obtém a contagem de pacientes
    //             setCount(parseInt(count)); // converte a string em número e define o estado
    //         })
    //         .catch(error => console.log('não esta contadno pacientes'));
    // }, []);

    return (
        <div style={{backgroundColor: '#ff0808',padding: '5px', width: '12px', borderRadius: '100%', marginLeft: '95px', marginTop: '-10px'}}>
            <h6 style={{textAlign: 'center'}}> 0</h6>
        </div>
    );
};

export default Count;